<i18n>
{
  "fr": {
    "upload": "Sélectionnez un fichier",
    "confirm-delete-title": "Retirer le fichier",
    "confirm-delete-message": "Êtes-vous certain de vouloir retirer le fichier «\u00A0{name}\u00A0»\u00A0?",
    "confirm-delete-confirm": "Retirer",
    "confirm-delete-cancel":"Annuler"
  },
  "en": {
    "upload": "Choose file",
    "confirm-delete-title": "Remove file",
    "confirm-delete-message": "Are you sure you want to remove the file \"{name}\"?",
    "confirm-delete-confirm": "Remove",
    "confirm-delete-cancel":"Cancel"
  }
}
</i18n>
<template>
  <div>
    <div v-if="value">
      <b-button size="is-small" type="is-danger" outlined @click="removeFile" class="mr-2">
        <b-icon icon="trash" />
      </b-button>
      <a :href="value" target="_blank">{{ fileName }}</a>
    </div>
    <b-field v-else class="file is-primary">
      <b-upload class="file-label" @input="uploadFile" v-model="selectedFile">
        <span class="file-cta">
          <b-icon icon="file-upload" class="mr-1" />
          {{ $t('upload') }}
        </span>
      </b-upload>
    </b-field>
  </div>
</template>
<script>
import { uploadPublicFile } from '@/services/file-upload'
export default {
  props: {
    id: String,
    value: String
  },
  data() {
    return {
      selectedFile: null
    }
  },
  computed: {
    fileName() {
      if (!this.value) return null
      return this.value.split('/').slice(-1)[0]
    }
  },
  methods: {
    removeFile() {
      this.$buefy.dialog.confirm({
        title: this.$t('confirm-delete-title'),
        message: this.$t('confirm-delete-message', { name: this.fileName }),
        cancelText: this.$t('confirm-delete-cancel'),
        confirmText: this.$t('confirm-delete-confirm'),
        type: 'is-danger',
        onConfirm: () => {
          this.$emit('input', null)
          this.$emit('save')
        }
      })
    },
    async uploadFile() {
      try {
        const { url } = await uploadPublicFile(this.selectedFile)

        this.$emit('input', url)
        this.$emit('save')
      } finally {
        this.selectedFile = null
      }
    }
  }
}
</script>